import { render, staticRenderFns } from "./serverShift.vue?vue&type=template&id=09c063e1&scoped=true&"
import script from "./serverShift.vue?vue&type=script&lang=js&"
export * from "./serverShift.vue?vue&type=script&lang=js&"
import style0 from "./serverShift.vue?vue&type=style&index=0&id=09c063e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c063e1",
  null
  
)

export default component.exports